// @flow
import * as React from 'react';
import styled, { withTheme } from 'styled-components';
import { translate } from 'react-i18next';

import { Numeric, Currency } from 'common/components/Number';
import Card from 'common/components/Card';
import Proposition from 'common/modules/proposition/domain/proposition';

const SCard = styled(Card) `
display: flex;
justify-content: space-around;
`;

const Metric = styled.div`
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
margin-top: ${({ theme }) => theme.metrics.margin}px;
margin-bottom: ${({ theme }) => theme.metrics.margin}px;
`;

const MetricTitle = styled.div`
margin-bottom: 8px;
color: ${({ theme }) => theme.colors.primaryText};
`;

const MetricNumber = styled.p`
color: ${({ theme }) => theme.colors.primary};
font-size: 30px;
margin: 0px;
`;

type Props = {
  proposition: Proposition,
  t: any;
}

function TotalSummaryMetrics({ proposition, t }: Props) {
  const summary = proposition.getTotalSummary();
  return (
    <SCard>
      <Metric>
        <MetricTitle>{t('numberOfOpportunities')}</MetricTitle>
        <MetricNumber><Numeric value={summary.numberOfOpportunities} roundAt={0} /></MetricNumber>
      </Metric>
      <Metric>
        <MetricTitle>{t('totalCost')}</MetricTitle>
        <MetricNumber><Currency value={summary.totalCost} /></MetricNumber>
      </Metric>
      <Metric>
        <MetricTitle>{t('costPerThousand')}</MetricTitle>
        <MetricNumber><Currency value={summary.costPerThousand} /></MetricNumber>
      </Metric>
      <Metric>
        <MetricTitle>{t('impressions')}</MetricTitle>
        <MetricNumber><Numeric value={summary.impressions} roundAt={0} /></MetricNumber>
      </Metric>
    </SCard>
  );
}

export default translate()(withTheme(TotalSummaryMetrics));



// WEBPACK FOOTER //
// ./src/common/modules/sales/components/TotalSummaryMetrics.js